import { takeLatest, put, call } from "redux-saga/effects"
import callApi from "./helpers"
import * as types from "../constants/actionTypes"
import * as appActions from "../actions/appActions"
import url from "url"
import { API_SERVER_URL } from "../config"
import _ from "lodash"


export function* validateResetPasswordToken(actions) {
    const config = {
        mode: "cors",
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
            query: `query ValidateResetPasswordToken {
                ValidateResetPasswordToken(
                    token: "${actions.payload.token}",
                    serviceName: "${actions.payload.serviceName.replace("_", " ")}"
                ) {
                    token
                    expirationDate
                }
            }`,
        }),
    }

    const uri = url.resolve(API_SERVER_URL, "")

    try {
        yield call(callApi, () => fetch(uri, config), [types.RESET_PASSWORD.GET.SUCCESS, types.RESET_PASSWORD.GET.FAILURE])
    } catch (error) {
        yield put(appActions.showMessage("Request Error", error.message, "danger"))
    }
}

export function* resetPassword(actions) {
    const config = {
        mode: "cors",
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
            query: `mutation ResetPassword {
                ResetPassword(
                    token: "${actions.payload.token}",
                    password: "${actions.payload.password}",
                    cpassword: "${actions.payload.cpassword}"
                ) {
                    message
                }
            }
            `,
        }),
    }

    const uri = url.resolve(API_SERVER_URL, "")

    try {
        const callResponse = yield call(callApi, () => fetch(uri, config), [types.RESET_PASSWORD.SET.SUCCESS, types.RESET_PASSWORD.SET.FAILURE])
        if (_.has(callResponse, "errors")) {
            yield put(appActions.showMessage("Request Error", callResponse.errors[0].exceptions[0], "danger"))
        } 
    } catch (error) {
        yield put(appActions.showMessage("Request Error", error.message, "danger"))
    }
}

export function* watchResetPasswordRequest() {
    yield takeLatest(types.RESET_PASSWORD.GET.REQUEST, validateResetPasswordToken);
    yield takeLatest(types.RESET_PASSWORD.SET.REQUEST, resetPassword);
}
